import React from 'react';
import { useParams } from 'react-router-dom';
import { extractIdFromPath } from '@/utils';
import Zone from './Zone';

export default function ZoneWrapper() {
    const { zonePath } = useParams();
    return <Zone zoneId={extractIdFromPath(zonePath)} />;
}
